export const leadReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_LEAD_LIST_REQUEST":
      return { ...state, loading: true, leadList: null };

    case "GET_LEAD_LIST_SUCCESS":
      return { ...state, loading: false, leadList: action.payload };

    case "GET_LEAD_LIST_FAILED":
      return { ...state, loading: false, leadList: null, error: action.payload };

    case "GET_LEAD_REQUEST":
      return { ...state, loading: true, lead: null };

    case "GET_LEAD_SUCCESS":
      return { ...state, loading: false, lead: action.payload };

    case "GET_LEAD_FAILED":
      return { ...state, loading: false, lead: null, error: action.payload };

    case "CHANGE_LEAD_STATUS_REQUEST":
      return { ...state, loading: true };

    case "CHANGE_LEAD_STATUS_SUCCESS":
      return { ...state, loading: false };

    case "CHANGE_LEAD_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "LIST_ADDRESS_REQUEST":
      return { ...state, loading: true, addressList: null };

    case "LIST_ADDRESS_SUCCESS":
      return { ...state, loading: false, addressList: action.payload };

    case "LIST_ADDRESS_FAILED":
      return { ...state, loading: false, addressList: null, error: action.payload };

    case "ADD_ADDRESS_REQUEST":
      return { ...state, loading: true };

    case "ADD_ADDRESS_SUCCESS":
      return { ...state, loading: false };

    case "ADD_ADDRESS_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "REMOVE_ADDRESS_REQUEST":
      return { ...state, loading: true };

    case "REMOVE_ADDRESS_SUCCESS":
      return { ...state, loading: false };

    case "REMOVE_ADDRESS_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "CREATE_APPOINTMENT_REQUEST":
      return { ...state, loading: true };

    case "CREATE_APPOINTMENT_SUCCESS":
      return { ...state, loading: false };

    case "CREATE_APPOINTMENT_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};